/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/* eslint-env browser */

import template from './countdown-root.html';

// TODO neumí reagovat na změny v prop end
// TODO není ošetřeno na nevyplnění a nevalidní vstupy (např. -1)
// TODO vždy emitovat end při změně v prop end
// http://fareez.info/blog/countdown-timer-using-vuejs/
// http://flipclockjs.com/
export default {
  name: 'CountdownRoot',
  template,
  data() {
    return {
      remaining: 0
    };
  },
  destroyed() {
    this.stop();
  },
  methods: {
    getDelay() {
      return this.end - Date.now();
    },
    onEnd() {
      this.endTimeout = null;
      clearInterval(this.tickInterval);
      this.tickInterval = null;
      this.onTick();
      this.$emit('end');
    },
    onTick() {
      const delay = this.getDelay();
      this.remaining = Math.max(0, Math.round(delay / 1000));
    },
    start() {
      if (this.endTimeout || this.tickInterval) {
        throw new Error('Already started.');
      }
      const delay = this.getDelay();
      this.endTimeout = setTimeout(this.onEnd, delay);
      this.tickInterval = setInterval(this.onTick, 1000);
      this.onTick();
    },
    stop() {
      clearTimeout(this.endTimeout);
      this.endTimeout = null;
      clearInterval(this.tickInterval);
      this.tickInterval = null;
    }
  },
  mounted() {
    this.start();
  },
  props: {
    // TODO mohl by podporovat více vstupních typů (String, Date?)
    end: { type: Number }
  }
};
